import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BusinessAgentPerformance = () => {
  const [loading, setLoading] = useState(true);
  const [agentPerformance, setAgentPerformance] = useState([]);

  useEffect(() => {
    const fetchAgentPerformance = async () => {
      try {
        const response = await axios.get(
          `https://citi-mobile-app.onrender.com/salessupervisors/transaction-details`
        );
        setAgentPerformance(response.data.data);
      } catch (error) {
        console.error('Error fetching agent performance:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentPerformance();
  }, []);

  // Function to download CSV
  const downloadCSV = () => {
    const headers = [
      'No,Agent Name,Total Sales,Delivered,Pending,Total Amount',
    ];
    const rows = agentPerformance.map((agent, index) =>
      [
        index + 1,
        `${agent.firstName} ${agent.lastName}`,
        agent.email,
        agent.totalSalesRaised,
        agent.deliveredOrders,
        agent.pendingOrders,
        `₦${agent.totalAmount}`,
      ].join(',')
    );

    const csvContent = [headers, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'agent_performance.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:ml-60 bg-white mt-20 rounded-md">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Sales Agent Performance Table</h3>
        <button
          onClick={downloadCSV}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200"
        >
          Download CSV
        </button>
      </div>

      {/* Scrollable Table Wrapper */}
      <div className="w-full overflow-x-auto">
        <table className="min-w-full bg-white rounded-lg shadow-md">
          <thead>
            <tr className="text-left bg-[#F8F8F8] uppercase text-xs sm:text-sm leading-normal">
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">No</th>
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">Agent Name</th>
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">Agent email</th>
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">Total Sales</th>
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">Delivered</th>
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">Pending</th>
              <th className="py-2 px-2 sm:px-6 text-[#1E1E1E]">Total Amount</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 text-xs sm:text-sm font-light">
            {agentPerformance.map((agent, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-100"
              >
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  {index + 1}
                </td>
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  {agent.firstName} {agent.lastName}
                </td>
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  {agent.email}
                </td>
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  {agent.totalSalesRaised}
                </td>
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  {agent.deliveredOrders}
                </td>
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  {agent.pendingOrders}
                </td>
                <td className="py-2 px-2 sm:px-6 text-[#1E1E1E] font-bold">
                  ₦{agent.totalAmount}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BusinessAgentPerformance;
